export const svgImageStyles = { root: { boxSizing: 'border-box', padding: 24 } };
